<template>
	<el-table :data="tableData" border style="width: 100%">
		<el-table-column
			label="序号"
			align="center"
			width="50"
			type="index"
		></el-table-column>
		<el-table-column
			v-for="(item, index) in data.columnList"
			:key="index"
			:label="item.label"
			:prop="item.prop"
			align="center"
		>
			<template #default="scope" v-if="item.prop === 'userType'">
				{{ userTypeInfo[scope.row.userType] || "" }}
			</template>
			<template #default="scope" v-else-if="item.prop === 'isDelete'">
				{{ scope.row.isDelete == 0 ? "正常" : "删除" }}
			</template>
		</el-table-column>
		<el-table-column label="操作" align="center" width="250">
			<template #default="scope">
				<el-button
					type="primary"
					size="mini"
					@click="handleEdit(scope.row)"
					>编辑</el-button
				>
				<el-button
					v-if="
						scope.row.userTypeAuditStatus &&
						scope.row.userTypeAuditStatus == 1
					"
					type="primary"
					size="mini"
					@click="handleAudit(scope.row)"
					>审核</el-button
				>
        <el-button
            type="primary"
            size="mini"
            @click="handleDetail(scope.row)">
            详情
        </el-button>
        <el-button
            type="primary"
            size="mini"
            @click="handleBestow(scope.row)">
            赠送
        </el-button>
			</template>
		</el-table-column>
	</el-table>
	<!-- 审核 -->
	<audit-user ref="AuditUserRef" :currentData="data.currentData"></audit-user>
	<!-- 修改 用户信息 -->
	<add-edit-user
		ref="AddEditUserRef"
		scene="edit"
		:currentData="data.currentData"
	></add-edit-user>
    <!--修改 赠送金额-->
    <add-edit-bestow
        ref="AddEditBestowRef"
        scene="edit"
        :currentData="data.currentData"
    ></add-edit-bestow>
    <!--用户详情-->
    <user-detail
        ref="userDetailRef"
        :currentData="data.currentData"
    ></user-detail>
</template>

<script>
import { reactive } from "@vue/reactivity";
import { inject, ref } from "vue";
import AuditUser from "./children/audit-user.vue";
import AddEditUser from "./children/add-edit-user.vue";
import AddEditBestow from "./children/add-edit-bestow.vue";
import UserDetail from "./children/user-detail.vue";
export default {
	props: {
		tableData: Array,
	},
	components: {
		AuditUser,
		AddEditUser,
        UserDetail,
        AddEditBestow
	},
	setup() {
		const userTypeInfo = inject("userTypeInfo");
		const AddEditUserRef = ref(null);
		const AuditUserRef = ref(null);
        const userDetailRef = ref(null);
        const AddEditBestowRef = ref(null)
		const data = reactive({
			currentData: {},
			columnList: [
				{
					label: "姓名",
					prop: "name",
				},
				{
					label: "手机号",
					prop: "phone",
				},
				{
					label: "类型",
					prop: "userType",
				},
				{
					label: "创建时间",
					prop: "createTime",
				},
				{
					label: "实充金额",
					prop: "deposit",
				},
        {
            label: "赠送金额",
            prop: "giftAmount",
        },
				{
					label: "状态",
					prop: "isDelete",
				},
			],
		});

		const handleEdit = (val) => {
			data.currentData = val;
			AddEditUserRef.value.handleToggle(true);
		};
    const handleDetail = (val) => {
        data.currentData = val;
        userDetailRef.value.handleToggle(true);
    };
    const handleBestow = (val) => {
        data.currentData = val;
        AddEditBestowRef.value.handleToggle(true);
    };

        const handleAudit = (val) => {
			data.currentData = val;
			AuditUserRef.value.handleToggle(true);
		};
		return {
			AddEditUserRef,
			AuditUserRef,
            userDetailRef,
            AddEditBestowRef,
			handleAudit,
			handleEdit,
        handleDetail,
            handleBestow,
			data,
			userTypeInfo,
		};
	},
};
</script>

<style  scoped>
</style>
